// extracted by mini-css-extract-plugin
module.exports = {"filter-item-wrapper":"FilterCheckboxItem_filter-item-wrapper__3lZIE"};